import { dscvrIcApi } from '@/shared/api';
import type { NotificationPageQuery } from '../types';

export const useNotificationQuery = (query: NotificationPageQuery) => {
  return dscvrIcApi.notification.getNotifications(query);
};
